import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  width: "25",
  height: "25",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "geluid aan"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 4L2 12.5l8.5 8.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 9h7v7H1z"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.563 16.438l7.875-7.876M21.438 16.438l-7.875-7.876"
})))));